module.exports = __webpack_public_path__ + "img/02_uk.dfdaff96.svg";